<template>
    <div class="EnrollSingleParticipantDiv">
        <div class="container-fluid">
            <div class="row vertical-align margin-Top-2Perc font-weight-bold" v-if="selectedOption === -1">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 font-size-20px width cursor-pointer" v-on:click="updateSelectedOption($event,1)">
                    1.
                </div>
                <div class="col-md-6 col-lg-6 text-align-left font-size-20px cursor-pointer" v-on:click="updateSelectedOption($event,1)">
                    Create and Enroll Single Participant
                </div>
                <div class="col-md-3 col-lg-3">
                </div>
            </div>
            <div class="row vertical-align margin-Top-2Perc font-weight-bold" v-if="selectedOption === -1">   
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 font-size-20px width cursor-pointer" v-on:click="updateSelectedOption($event,2)">
                    2.
                </div>
                <div class="col-md-6 col-lg-6 text-align-left font-size-20px cursor-pointer" v-on:click="updateSelectedOption($event,2)">
                    Enroll Existing Single Participant
                </div>
                <div class="col-md-3 col-lg-3">
                </div>   
            </div>
            <!-- Start of create and enroll single participant -->
            <create-and-enroll-single-participant v-if="selectedOption === 1" @isBackPressed="updateSelectedOptionValOnBackPressed"></create-and-enroll-single-participant>
            <!-- End of create and enroll single participant -->
            <!-- Start of enroll Existing single participant -->
            <enroll-existing-single-participant v-if="selectedOption === 2" @isBackPressed="updateSelectedOptionValOnBackPressed"></enroll-existing-single-participant>
            <!-- End of enroll Existing single participant -->      
        </div>
    </div>    
</template>

<script>
// import CreateAndEnrollSingleParticipant from '@/components/CreateAndEnrollSingleParticipant'
import EnrollExistingSingleParticipant from '@/components/EnrollExistingSingleParticipant'
export default {
  data: function () {
    return {
      selectedOption: 2
    }
  },
  methods: {
    updateSelectedOption (event, valueToUpdate) {
      this.selectedOption = valueToUpdate
    },
    updateSelectedOptionValOnBackPressed (value) {
      // AK: need to trigger this function when user pressed back from sub-child screen
      this.selectedOption = value
    }
  },
  components: {
    // 'create-and-enroll-single-participant': CreateAndEnrollSingleParticipant,
    'enroll-existing-single-participant': EnrollExistingSingleParticipant
  },
  name: 'EnrollSingleParticipantDiv'
}
</script>

<style scoped>
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.upload-csv-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
</style>





// WEBPACK FOOTER //
// src/components/EnrollSingleParticipant.vue